import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Link, NavLink } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import MobileCTA from "@/components/MobileCTA";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Portfolio from "@/pages/Portfolio";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import { LOGO, SOCIALS } from "@/data/media";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

const FOOTER_LINKS = [
  { to: "/services", label: "What's Possible" },
  { to: "/portfolio", label: "Work" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-[var(--border)] bg-[var(--bg)] px-6 py-16">
      <div className="mx-auto flex max-w-7xl flex-col gap-10 md:flex-row md:items-center md:justify-between">
        <div>
          <img src={LOGO} alt="AberCal" className="h-8 w-auto" />
          <p className="mt-4 text-[11px] uppercase tracking-[0.3em] text-gold">Software should adapt to your business.</p>
          <p className="mt-3 font-head text-lg italic text-[var(--text-2)]">If you can dream it, I can build it.</p>
        </div>
        <div className="flex flex-wrap gap-8">
          {FOOTER_LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} className="text-xs uppercase tracking-[0.25em] text-[var(--text-2)] hover:text-[var(--text)]">{l.label}</NavLink>
          ))}
        </div>
        <div className="flex gap-6">
          {SOCIALS.map((s) => (
            <a key={s.label} href={s.href} className="text-xs uppercase tracking-[0.25em] text-[var(--text-2)] hover:text-gold">{s.label}</a>
          ))}
        </div>
      </div>
      <p className="mx-auto mt-12 max-w-7xl text-[10px] uppercase tracking-[0.25em] text-[var(--muted)]">
        © {new Date().getFullYear()} AberCal · Calgary, AB · [contact details to be confirmed]
      </p>
    </footer>
  );
}

function App() {
  return (
    <HelmetProvider>
    <div className="App relative">
      <div className="grain-overlay" />
      <Toaster position="top-center" theme="dark" />
      <BrowserRouter>
        <ScrollToTop />
        <Nav />
        <main className="pb-14 md:pb-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <MobileCTA />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
